<ng-content></ng-content>
<ng-container *ngFor="let column of columns; trackBy: trackBy">
  <th
    pReorderableColumn
    pResizableColumn
    [pSortableColumn]="column.field"
    [pSortableColumnDisabled]="!column.sortable"
    [style.width.px]="column.width"
    [style.maxWidth.px]="column.width"
    [style.flexBasis.px]="column.width"
    [style.justifyContent]="column.headerAlign | columnAlignment"
    [attr.data-field]="column.field"
    [pTooltip]="column.header | nl2br"
    [escape]="false"
    tooltipPosition="bottom"
    [showDelay]="500"
  >
    <ng-container *ngIf="column.type === 'icon' && column.data && column.data.headerIconClass">
      <i [ngClass]="column.data.headerIconClass"></i>
    </ng-container>

    <ng-container *ngIf="column.type !== 'icon'">
      <span [innerHTML]="column.header | nl2br"></span>
    </ng-container>

    <z-sort-icon [field]="column.field" *ngIf="column.sortable"></z-sort-icon>
  </th>
</ng-container>
